<template>
  <div>
    <div class="box6">
      <pageTitle
        title="职业前景广&nbsp;&nbsp;就业薪酬多"
        text="由于市场招聘需求驱动，具备自动化、性能测试、接口测试等中高级技能的岗位薪资相对更为可观"
        titColor="#86909C"
      />
      <div class="img">
        <img src="../../../assets/coursePage/softwareTest/box6/content.png" />
      </div>
      <div class="content">
        <h1>博学谷毕业学生起点</h1>
        <p>中级测试工程师</p>
        <i>2-3 年测试经验</i>
      </div>
      
    </div>
    <div class="title">
      <img src="../../../assets/coursePage/softwareTest/box6/title.png" />
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/softwareTest/box6/gongneng.png"),
          tip: "* 数据来源：某准招聘网络平台，取样76956份职场数据<br/>（截止2023年1月14日）",
          title: "功能测试薪资水平",
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box6/zidonghua.png"),
          tip: "* 数据来源：某准招聘网络平台，取样168554份职场数据<br/>（截止2023年1月14日）",
          title: "自动化测试薪资水平",
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box6/xingneng.png"),
          tip: "* 数据来源：某准招聘网络平台，取样50187份职场数据<br/>（截止2023年1月14日）",
          title: "性能测试薪资水平",
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box6/jiekou.png"),
          tip: "* 数据来源：某准招聘网络平台，取样3131231份职场数据（截止2023年1月14日）",
          title: "接口测试薪资水平",
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box6/kaifa.png"),
          tip: "* 数据来源：某准招聘网络平台，取样354189份职场数据（截止2023年1月14日）",
          title: "测试开发薪资水平",
        },
      ],

      cur: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.item-content {
  background: linear-gradient(90deg, #dbf4fe 0%, #edf6ff 100%);
  box-shadow: 0px 3px 6px -2px rgba(202, 219, 235, 0.87);
  border-radius: 20px;
  border: 1px solid #e0ebf6;
  padding: 20px 12px 20px;
  box-sizing: border-box;
  overflow: hidden;
  .tip {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #b9c8d9;
    line-height: 40px;
    margin: 20px 0 0;
  }
}
.item-title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 0 34px;
  .title-left,
  .title-right {
    width: 22px !important;
    height: 18px !important;
  }
  p {
    margin: 0 22px;
    position: relative;
    b {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #388bdc;
      line-height: 28px;
      position: relative;
      z-index: 2;
    }
    i {
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      width: 262px;
      height: 6px;
      background: #e1ecff;
      border-radius: 3px;
    }
  }
}
.img {
  margin-top: 60px;
  img {
    width: 100%;
  }
}
.title {
  img {
    width: 100%;
  }
}
.content {
  background: url("../../../assets/coursePage/softwareTest/box6/bg.png")
    no-repeat;
  background-size: 100% 100%;
  background-origin: center;
  width: 103.5%;
  height: 246px;
  margin-left: -1.5%;
  box-sizing: border-box;
  padding: 38px 0 0 60px;
  h1 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #2a81ff;
    line-height: 52px;
  }
  p {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d2129;
    line-height: 52px;
    margin: 14px 0 0;
  }
  i {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #86909c;
    line-height: 44px;
  }
}
.tip {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b9c8d9;
  line-height: 34px;
  text-align: center;
}
.btn {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 96px;
  text-align: center;
  width: 686px;
  height: 96px;
  background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);
  border-radius: 48px;
  display: block;
  margin-top: 48px;
}
.box6 {
  padding: 80px 32px 48px;
  box-sizing: border-box;
  width: 100%;
  // background: url("../../../assets/coursePage/softwareTest/box3/bg.png") no-repeat;
  // background-size: cover;
  // background-origin: center;

  .subject-box {
    margin: 24px auto 28px;
    position: relative;

    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
  }

  .swiper-slide {
    padding-bottom: 38px;
  }

  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }

  .swiper-slide {
    width: 100%;
    display: flex;
    justify-content: center;

    box-sizing: border-box;
    .box {
      position: relative;
      overflow: hidden;
      text-align: center;

      img {
        width: 100%;
        height: auto;

        margin: 0;
      }
    }
  }
}
</style>
